import { createTodoList } from '@erikdakoda/todo/ai-tools/createTodoList';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(createTodoList);
